module.exports = __webpack_public_path__ + "img/avatar-profesionist.bb95d81c.svg";